export default __webpack_public_path__ + "static/media/house-autmn2.85d59d08.jpg";